/* eslint no-param-reassign: 0 */

const initialState = {};

const gettersDef = {};

const actions = {
  fetchAppLicenses(
    { dispatch, rootGetters },
    { params, filterByActiveCompany = true } = {}
  ) {
    const mergedParams = {
      ...params,
      company: filterByActiveCompany
        ? rootGetters["auth/activeCompany"].id
        : undefined
    };
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/app-licenses/", params: mergedParams },
      { root: true }
    );
  }
};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
